import { render, staticRenderFns } from "./NbNewUploaderDragAndDrop.vue?vue&type=template&id=7892e458&scoped=true&lang=pug"
import script from "./NbNewUploaderDragAndDrop.vue?vue&type=script&lang=ts"
export * from "./NbNewUploaderDragAndDrop.vue?vue&type=script&lang=ts"
import style0 from "./NbNewUploaderDragAndDrop.vue?vue&type=style&index=0&id=7892e458&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892e458",
  null
  
)

export default component.exports